<mat-dialog-content
  class="add-background-color"
>
  <equine-ui-nx-donation-receipt
    [type]="'DIALOG'"
    [amount]="data.amount"
    [date]="data.date"
  ></equine-ui-nx-donation-receipt>

</mat-dialog-content>
<mat-dialog-actions  [align]="'end'">
  <button mat-raised-button (click)="printDonation()">PRINT
    <mat-icon iconPositionEnd>print</mat-icon>
  </button>
  <button mat-raised-button mat-dialog-close>CLOSE</button>
</mat-dialog-actions>